var map = {
	"./Contact/Contact page top img_desktop.jpg": "4dbf",
	"./Contact/Contact page top img_mobile.jpg": "3e09",
	"./Home_PU/PRODUCT CARD_ PRINTING LEATHER_deskstop.jpg": "7c08",
	"./Home_PU/PRODUCT CARD_ PRINTING LEATHER_mobile.jpg": "5415",
	"./Home_PU/PRODUCT CARD_ SHIFTING EFFECT LEATHER _deskstop.jpg": "c02f",
	"./Home_PU/PRODUCT CARD_ SHIFTING EFFECT LEATHER_mobile.jpg": "c33e",
	"./Home_PU/PRODUCT CARD_ TWO-TONE LEATHER_deskstop.jpg": "c9cf",
	"./Home_PU/PRODUCT CARD_ TWO-TONE LEATHER_mobile.jpg": "1096",
	"./Home_PU/PRODUCT CARD_4-WAY STRETCHABLE LEATHER_deskstop.jpg": "0cfb3",
	"./Home_PU/PRODUCT CARD_4-WAY STRETCHABLE LEATHER_mobile.jpg": "1e31",
	"./Home_PU/PRODUCT CARD_ANTI-BACTERIAL PU_deskstop.jpg": "6436",
	"./Home_PU/PRODUCT CARD_ANTI-BACTERIAL PU_mobile.jpg": "a5c9",
	"./Home_PU/PRODUCT CARD_DOUBLE COATING_deskstop.jpg": "a14b",
	"./Home_PU/PRODUCT CARD_DOUBLE COATING_mobile.jpg": "a171",
	"./Home_PU/PRODUCT CARD_HOT MELT FILM_deskstop.jpg": "c4aa",
	"./Home_PU/PRODUCT CARD_HOT MELT FILM_mobile.jpg": "1424",
	"./Home_PU/PRODUCT CARD_MICROFIBER _deskstop.jpg": "5c36",
	"./Home_PU/PRODUCT CARD_MICROFIBER _mobile.jpg": "0f27",
	"./Home_PU/PRODUCT CARD_PROTE PU_deskstop.jpg": "434d",
	"./Home_PU/PRODUCT CARD_PROTE PU_mobile.jpg": "3895",
	"./Home_PU/PRODUCT CARD_PU SKIN_deskstop.jpg": "ed2b",
	"./Home_PU/PRODUCT CARD_PU SKIN_mobile.jpg": "827c",
	"./Home_PU/PRODUCT CARD_TPU HOT MELT FILM_deskstop.jpg": "39bb",
	"./Home_PU/PRODUCT CARD_TPU HOT MELT FILM_mobile.jpg": "0d99",
	"./Home_PU/PRODUCT CARD_WPN PFCs FREE LEATHER_deskstop.jpg": "51a1",
	"./Home_PU/PRODUCT CARD_WPN PFCs FREE LEATHER_mobile.jpg": "b84b",
	"./Home_PVC/PRODUCT CARD_clear_deskstop.jpg": "f760",
	"./Home_PVC/PRODUCT CARD_clear_mobile.jpg": "8708",
	"./Home_PVC/PRODUCT CARD_semi grid_deskstop.jpg": "3bd2",
	"./Home_PVC/PRODUCT CARD_semi grid_mobile.jpg": "6526",
	"./Home_PVC/PRODUCT CARD_tape_deskstop.jpg": "808f",
	"./Home_PVC/PRODUCT CARD_tape_mobile.jpg": "fd3b",
	"./Products/PU/081065d8c8904740e685fe.jpg": "3031",
	"./Products/PU/Asics-logo.jpg": "83a3",
	"./Products/PU/Bags PU products application horizontal_desktop.jpg": "410b",
	"./Products/PU/Converse-Zeichen-2003-2007-650x366.jpg": "c498",
	"./Products/PU/Crocs.jpg": "cedc",
	"./Products/PU/Funiture PU products application horizontal_desktop.jpg": "7c3d",
	"./Products/PU/Gloves PU products application horizontal_desktop.jpg": "778a",
	"./Products/PU/NO SEW_deskstop.jpg": "0305",
	"./Products/PU/NoSew/HOT MELT FILM products discription_deskstop.jpg": "689b",
	"./Products/PU/NoSew/TPU HOT MELT FILM products discription_deskstop.jpg": "755f",
	"./Products/PU/NoSew/page top img_no sew_desktop.jpg": "7b07",
	"./Products/PU/NoSew/page top img_no sew_mobile.jpg": "8cf4",
	"./Products/PU/PU page top img_desktop.jpg": "0aa6",
	"./Products/PU/PU page top img_mobile.jpg": "584a",
	"./Products/PU/PU/4-WAY STRETCHABLE PU products discription1_deskstop.jpg": "1a34",
	"./Products/PU/PU/4-WAY STRETCHABLE PU products discription2_deskstop.jpg": "a069",
	"./Products/PU/PU/ANTI-BACTERIAL PU products discription1_deskstop.jpg": "aa20",
	"./Products/PU/PU/DOUBLE COATING PU products discription1_deskstop.jpg": "b21d",
	"./Products/PU/PU/DOUBLE COATING PU products discription2_deskstop.jpg": "b933",
	"./Products/PU/PU/MICROFIBER PU products discription_deskstop.jpg": "8fc4",
	"./Products/PU/PU/PRINTING PU products discription_deskstop1.jpg": "cc4a",
	"./Products/PU/PU/PRINTING PU products discription_deskstop2.jpg": "3a5e",
	"./Products/PU/PU/PROTE PU products discription1_deskstop.jpg": "d097",
	"./Products/PU/PU/PROTE PU products discription2_deskstop.jpg": "ead5",
	"./Products/PU/PU/PU SKIN products discription1_deskstop.jpg": "8603",
	"./Products/PU/PU/PU SKIN products discription2_deskstop.jpg": "91ec",
	"./Products/PU/PU/PU products discription2_deskstop.jpg": "0ffd",
	"./Products/PU/PU/SHIFTING EFFECT PU products discription1_deskstop.jpg": "1a1b",
	"./Products/PU/PU/SHIFTING EFFECT PU products discription2_deskstop.jpg": "5d76",
	"./Products/PU/PU/SHIFTING EFFECT PU products discription3_deskstop.jpg": "9dab",
	"./Products/PU/PU/TWO-TONE PU products discription_deskstop.jpg": "83e4",
	"./Products/PU/PU/WPN PFCs FREE PU products discription1_deskstop.jpg": "5b09",
	"./Products/PU/PU/WPN PFCs FREE PU products discription2_deskstop.jpg": "8b74",
	"./Products/PU/PU/WPN PFCs FREE PU products discription3_deskstop.jpg": "cdf2",
	"./Products/PU/PU/page top img_PU_desktop.jpg": "97a6",
	"./Products/PU/PU/page top img_PU_mobile.jpg": "16f8",
	"./Products/PU/PU_deskstop.jpg": "7605",
	"./Products/PU/Processing/Embossing PU Processing1.jpg": "d9de",
	"./Products/PU/Processing/Embossing PU Processing2.jpg": "a7ea",
	"./Products/PU/Processing/Embossing PU Processing3.jpg": "e96e",
	"./Products/PU/Processing/Embossing PU Processing4.jpg": "6723",
	"./Products/PU/Processing/High-frequency PU Processing1.jpg": "e4aa",
	"./Products/PU/Processing/High-frequency PU Processing2.jpg": "7171",
	"./Products/PU/Processing/High-frequency PU Processing3.jpg": "ba2b",
	"./Products/PU/Processing/High-frequency PU Processing4.jpg": "43f0",
	"./Products/PU/Processing/printing PU Processing1.jpg": "d2ba",
	"./Products/PU/Processing/printing PU Processing2.jpg": "f995",
	"./Products/PU/Processing/printing PU Processing3.jpg": "e72f",
	"./Products/PU/Processing/printing PU Processing4.jpg": "6faf",
	"./Products/PU/Shoes PU products application straight_desktop.jpg": "7699",
	"./Products/PU/Vehicle PU products application horizontal_desktop.jpg": "ff29",
	"./Products/PU/emtmjd.png": "91cc",
	"./Products/PVC/Clear PVC Film/page top img_clear_desktop.jpg": "7fc5",
	"./Products/PVC/Clear PVC Film/page top img_clear_mobile.jpg": "757e",
	"./Products/PVC/Clear PVC Film/products application_Clear PVC1.jpg": "c857",
	"./Products/PVC/Clear PVC Film/products application_Clear PVC2.jpg": "2bff",
	"./Products/PVC/Clear PVC Film/products application_Clear PVC3.jpg": "ec7f",
	"./Products/PVC/Clear PVC Film/products application_Clear PVC4.jpg": "80cd",
	"./Products/PVC/Clear PVC Film/products application_Semi-rigid PVC4.jpg": "db61",
	"./Products/PVC/Clear PVC Film/products discription_Clear PVC Film1.jpg": "c931",
	"./Products/PVC/Clear PVC Film/products discription_Clear PVC Film2.jpg": "c463",
	"./Products/PVC/PVC Film_clear film_deskstop.jpg": "9b59",
	"./Products/PVC/PVC Film_semi_deskstop.jpg": "9379",
	"./Products/PVC/PVC Film_tape sheet_deskstop.jpg": "8daf",
	"./Products/PVC/PVC page top img_desktop.jpg": "44b2",
	"./Products/PVC/Semi-rigid PVC Film/page top img_semi_desktop.jpg": "7fd9",
	"./Products/PVC/Semi-rigid PVC Film/page top img_semi_mobile.jpg": "317a",
	"./Products/PVC/Semi-rigid PVC Film/products application_Semi-rigid PVC1.jpg": "cd7b",
	"./Products/PVC/Semi-rigid PVC Film/products application_Semi-rigid PVC2.jpg": "7f12",
	"./Products/PVC/Semi-rigid PVC Film/products application_Semi-rigid PVC3.jpg": "f261",
	"./Products/PVC/Semi-rigid PVC Film/products application_Semi-rigid PVC4.jpg": "b8db",
	"./Products/PVC/Semi-rigid PVC Film/products discription_Semi-rigid PVC Film1.jpg": "8b08",
	"./Products/PVC/Semi-rigid PVC Film/products discription_Semi-rigid PVC Film2.jpg": "8579",
	"./Products/PVC/Tape_PVC_Sheet/page top img_tape_desktop.jpg": "8ecb",
	"./Products/PVC/Tape_PVC_Sheet/page top img_tape_mobile.jpg": "0ada",
	"./Products/PVC/Tape_PVC_Sheet/products application_Tape PVC1.jpg": "2de6",
	"./Products/PVC/Tape_PVC_Sheet/products application_Tape PVC2.jpg": "d658",
	"./Products/PVC/Tape_PVC_Sheet/products application_Tape PVC3.jpg": "d975",
	"./Products/PVC/Tape_PVC_Sheet/products application_Tape PVC4.jpg": "eea2",
	"./Products/PVC/Tape_PVC_Sheet/products discription_tape PVC1.jpg": "41b1",
	"./Products/PVC/Tape_PVC_Sheet/products discription_tape PVC2.jpg": "a47d",
	"./Products/PVC/pvc film_page bottom_desktop.jpg": "05d5",
	"./Products/PVC/pvc film_page bottom_mobile.jpg": "11b5",
	"./Quality/Air pollution-01-01.jpg": "1b1d",
	"./Quality/GRS_CERTIFICATION 2020.jpg": "4829",
	"./Quality/Group_2182.png": "b35a",
	"./Quality/PU_ISO9001.jpg": "4763",
	"./Quality/PVC_ISO9001.jpg": "1ea4",
	"./Quality/Quality page top img_mobile.jpg": "4441",
	"./Quality/Quality_page_top_img_desktop.jpg": "d786",
	"./Quality/Toxic chemical-01.jpg": "a8d6",
	"./Quality/Waste management-01.jpg": "8991",
	"./Quality/Water pollution-01.jpg": "f646",
	"./banner/PU_Img1.jpg": "2b10",
	"./banner/PU_Img2.jpg": "b32f",
	"./banner/PU_Img3.jpg": "c4a8",
	"./banner/PU_Img4.jpg": "b5b7",
	"./banner/PVC_Img1.jpg": "b37f",
	"./banner/PVC_Img2.jpg": "d3f9",
	"./banner/PVC_Img3.jpg": "f30b",
	"./banner/PVC_Img4.jpg": "f9a5",
	"./banner/banner_desktop1.jpg": "99a0",
	"./banner/banner_desktop2.jpg": "13b3",
	"./banner/banner_desktop3.jpg": "88a6",
	"./banner/banner_desktop4.jpg": "f228",
	"./banner/banner_desktop5.jpg": "fc51",
	"./banner/banner_mobile1.jpg": "9841",
	"./banner/banner_mobile2.jpg": "f66c",
	"./banner/banner_mobile3.jpg": "cf4c",
	"./banner/banner_mobile4.jpg": "f969",
	"./banner/banner_mobile5.jpg": "f5dfc",
	"./code.jpg": "b209",
	"./company/company page top img_desktop.jpg": "c687",
	"./company/company page top img_mobile.jpg": "b1a8",
	"./company/company_history1958.jpg": "f352",
	"./company/company_history1975.jpg": "88b1",
	"./company/company_history1996.jpg": "7ac9",
	"./company/company_history2001.jpg": "7547",
	"./company/company_history2016.jpg": "65fd",
	"./company/company_introduce1.jpg": "5a42",
	"./company/company_introduce2.jpg": "44c5",
	"./company/company_page bottom_desktop.jpg": "19c2",
	"./home_backgroundImg1.png": "4b6e",
	"./home_backgroundImg2.png": "2e38",
	"./home_backgroundImg3.png": "9da8",
	"./home_our products_PU.jpg": "13b4",
	"./home_our products_PVC.jpg": "7352",
	"./home_page bottom_desktop.jpg": "006c",
	"./home_page bottom_mobile.jpg": "9837",
	"./homecard_company.jpg": "ffad",
	"./homecard_quality.jpg": "1bac",
	"./logo.png": "cf05",
	"./logo_white.png": "428c",
	"./nanya-plastics-mall-IMG.png": "a22a",
	"./pdfIcon.png": "1006",
	"./pdfIcon.svg": "c92f",
	"./pdfIcon_blue.png": "fc77",
	"./whyItem_01.png": "6708",
	"./whyItem_02.png": "575e",
	"./whyItem_03.png": "f792",
	"./whyItem_04.png": "c0c7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";